export const blogData = [
  {
    title: 'Building GenAI apps with Amazon Sagemaker',
    excerpt: 'My Sagemaker RAG workshop featured in AWS\'s partner series. Check the workshop in the \'Projects\' section.',
    url: 'https://aws.amazon.com/blogs/apn/pioneering-startups-unleash-enterprise-value-with-amazon-sagemaker-incubator/#:~:text=Read%20about%20the%20solution%20on%20Weaviate%20blog.',
    date: 'Nov 2025',
    // readTime: '9 min read',
    tags: ['RAG', 'AWS', 'SageMaker Unified Studio', 'Semantic Search', 'Weaviate'],
    image: '/images/blog/aws-blog.png',
    featured: true,
  },
  {
    title: 'Evals in Enterprise AI Workflows with ArizeAI',
    excerpt: 'Hands-on deep dive into designing robust gen AI capable enterprise workflows with Arize AI and Weaviate',
    url: 'https://weaviate.io/blog/evals-enterprise-workflows-3',
    date: 'Nov 2025',
    readTime: '20 min read',
    tags: ['Concepts', 'Agentic', 'Arize AI', 'Evals', 'How-To', 'Weaviate'],
    image: '/images/blog/evals-arize.jpg',
    featured: true,
  },
  // {
  //   title: 'Building RAG Applications with AWS SageMaker Studio',
  //   excerpt: 'A guide to seamlessly transform data sitting in lakes and warehouses for GenAI capable applications - legacy data to RAG with AWS SageMaker UnifiedStudio and Weaviate.',
  //   url: 'https://weaviate.io/blog/sagemaker-studio-rag',
  //   date: 'Oct 2025',
  //   readTime: '9 min read',
  //   tags: ['RAG', 'AWS', 'SageMaker Unified Studio', 'Semantic Search', 'Weaviate'],
  //   image: '/images/blog/sagemaker-rag.jpg',
  //   featured: false,
  // },
  {
    title: 'Evals and Guardrails with Weights&Biases',
    excerpt: 'Hands-on patterns: LLM-as-Judge pattern with LangChain, Weights&Biases and Weaviate.',
    url: 'https://weaviate.io/blog/evals-guardrails-enterprise-workflows-2',
    date: 'Sept 2025',
    readTime: '10 min read',
    tags: ['Concepts', 'Agentic Workflows', 'Langchain', 'Weights&Biases', 'Evals', 'Guardrails', 'Weaviate', 'How-To'],
    image: '/images/blog/evals-wnb.jpg',
    featured: true,
  },
  {
    title: 'Enterprise Workflows with LangChain and Weaviate',
    excerpt: 'LangChain and Weaviate typescript v3 power scalable AI with fast, type-safe RAG workflows, practical code, and future-ready features like LLM eval and event-driven design.',
    url: 'https://weaviate.io/blog/enterprise-workflow-langchain-weaviate',
    date: 'July 2025',
    readTime: '7 min read',
    tags: ['LangChain', 'Enterprise', 'Workflows', 'RAG', 'Weaviate'],
    image: '/images/blog/langchain.jpg',
    featured: false,
  },
  {
    title: 'When Good Models Go Bad: Understanding model decay',
    excerpt: 'A strategic guide to the costs, risks and rewards of upgrading embedding models in production AI.',
    url: 'https://weaviate.io/blog/when-good-models-go-bad',
    date: 'Oct 2025',
    readTime: '13 min read',
    tags: ['Model Evaluation', 'Embeddings', 'OpenAI', 'Anthropic', 'Concepts', 'Weaviate'],
    image: '/images/blog/models-good-bad.jpg',
    featured: false,
  },
  {
    title: 'Evals and Guardrails in Enterprise AI Workflows - Part 1',
    excerpt: 'Deep dive into evaluation strategies and implementing guardrails for production-ready AI systems.',
    url: 'https://weaviate.io/blog/evals-guardrails-enterprise-workflows-1',
    date: 'Aug 2025',
    readTime: '12 min read',
    tags: ['Concepts', 'Agentic Workflows', 'Enterprise', 'Evals', 'Guardrails', 'Weaviate', 'How-To'],
    image: '/images/blog/evals-part1.jpg',
    featured: false,
  },

];

// To add a new blog post, add an object with this structure:
/*
{
  title: 'Your Blog Title',
  excerpt: 'A brief description of what the article covers (2-3 sentences)',
  url: 'https://full-url-to-your-article',
  date: 'Month Year or specific date',
  readTime: 'X min read',
  tags: ['Tag1', 'Tag2', 'Tag3'], // 3-5 relevant tags
  featured: true | false, // Whether to show the featured badge
}
*/

